export default __webpack_public_path__ + "static/media/Background_00009.b7517f7d.png";